import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getDefaultAuthenticatedPath } from 'helpers/defaultAuthenticatedPath';

const PrivateRouteAuth = () => {
  const location = useLocation();
  const authenticated = useSelector(
    state => state.authentication.authenticated
  );
  const user = useSelector(state => state.user.zohoData);

  if (authenticated && user.id) {
    // get redirect parameter from URL
    const searchParams = new URLSearchParams(location.search);
    const redirectPath = searchParams.get('redirect');

    // validate and sanitize redirect path
    // only allow paths starting with / to prevent open redirect vulnerabilities
    const isValidRedirect =
      redirectPath &&
      redirectPath.startsWith('/') &&
      !redirectPath.startsWith('//');
    const targetPath = isValidRedirect
      ? redirectPath
      : getDefaultAuthenticatedPath(user);

    return <Navigate to={targetPath} replace />;
  }

  return <Outlet />;
};

export default PrivateRouteAuth;
